import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from '../errorHandler/message.service';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  standalone: false,
  selector: 'app-upload-form',
  templateUrl: './file-dnd.html'
})
export class UploadFormComponent {
  @ViewChild('fileInput') input: ElementRef;
  @Input() multipleSelection: boolean;
  @Input() acceptedExtensions: string;
  @Input() canRemove: boolean;
  @Input() canViewFile: boolean;
  @Input() disabled = false;
  @Input() maxFile: number;
  @Input() title: string;
  @Input() showDropZone = true;

  @Output()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filesChanged = new EventEmitter<any>();

  @Output()
  seeFileDefault = new EventEmitter<File>();

  @Output()
  fileSelected = new EventEmitter<File>();

  @Output()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fileNotAllowed = new EventEmitter<any>();

  isHovering: boolean;
  @Input() files: File[] = [];
  constructor(private msjService: MessageService, private readonly translocoService: TranslocoService) {
    this.canViewFile = false;
    this.title = this.translocoService.translate('process.wayOfSigning.attachDocumentationSubtitle');
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  startUpload(fileList: FileList) {
    if (this.disabled) {
      return;
    }

    if (!this.multipleSelection && fileList && fileList.length > 1) {
      this.msjService.showInfo(this.translocoService.translate('process.wayOfSigning.maximumFilesReached'));
      return;
    }

    if (this.files.length < Number(this.maxFile)) {
      if (fileList && fileList.length > 0) {
        let countNotAllowed = 0;
        for (let index = 0; index < fileList.length; index++) {
          const _fileExist = this.files.filter(f => f.name == fileList[index].name);
          if (this.files.filter(f => f.name == fileList[index].name).length > 0) {
            continue;
          }

          const file = fileList.item(index);
          const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
          const acceptedExtensions = this.acceptedExtensions
            .split(/[\s,]+/)
            .map(value => value.replace(/^\*+/, '').trim().toLowerCase())
            .filter(Boolean);
          if (acceptedExtensions.includes(extension)) {
            this.files.push(file);
          } else {
            countNotAllowed++;
          }
        }

        if (countNotAllowed > 0) {
          const all = countNotAllowed === fileList.length;
          this.fileNotAllowed.emit({allNotAllowed: all, countNotAllowed: countNotAllowed});
          if (all) {
            return;
          }
        }
      }
      if (this.input && this.input.nativeElement) {
        this.input.nativeElement.value = null;
      }
      this.filesChanged.emit({files: this.files, isAdding: true});
    } else {
      this.msjService.showInfo(this.translocoService.translate('process.wayOfSigning.maximumFilesReached'));
    }
  }

  remove(i: number) {
    this.files.splice(i, 1);
    this.filesChanged.emit({files: this.files, isAdding: false});
  }

  view(file: File) {
    this.fileSelected.emit(file);
  }

  viewBigFile(ev, file: File) {
    ev.preventDefault();
    ev.stopPropagation();
    this.seeFileDefault.emit(file);
  }
}
